import { render, staticRenderFns } from "./ChildApplications.vue?vue&type=template&id=4c633c91&scoped=true&"
import script from "./ChildApplications.vue?vue&type=script&lang=js&"
export * from "./ChildApplications.vue?vue&type=script&lang=js&"
import style0 from "./ChildApplications.vue?vue&type=style&index=0&id=4c633c91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c633c91",
  null
  
)

export default component.exports